import React, {useMemo,useState, useEffect} from "react";
import { Link,matchPath,useNavigate } from "react-router-dom";
import { useSelector,useDispatch,shallowEqual } from "react-redux";
import { clinicActions } from "@redux/actionCreators";
import { GlobalRoutePath } from "@router/constants";
import InputAdornment from '@mui/material/InputAdornment';
import TextFieldWrapper from "@components/common/TextFieldWrapper";
import ClearIcon from '@mui/icons-material/Clear';
import { useTheme } from "@mui/styles";
const { Grid,Box} = require("@mui/system")

const Sx = {
    root:{
        margin:'8px 16px 16px',
        minHeight:'40%'
    },
    search:{
        fontSize:14,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        '& .search':{
            margin:'8px 16px',
            width:200,
            '& .MuiInputBase-root':{
                paddingRight:1,
                color:'black',
                backgroundColor:'white'
            },
            '& .MuiInputBase-input':{
                padding:'2px 8px',
                fontSize:14,
                height:24
            },
            '& .MuiOutlinedInput-notchedOutline':{
                
                borderColor:'#1983D9',
            },
            '& .Mui-focused':{
                '& .MuiOutlinedInput-notchedOutline':{
                borderWidth:1,
                borderColor:'#1983D9 !important',
                }
            },
            '& .MuiInputAdornment-root':{
                cursor:'pointer',
                color:'#1983D9'
            },
            '& svg':{
                color:'#000',
                fontSize:20
            }
        }
    },
    group:{
        minHeight:'40vh',
        "& .heading":{
            fontWeight:700,
            fontSize:16,
            whiteSpace:'nowrap',
            padding:'4px 12px',
        }
    },
    groupItems:(theme)=>({
        padding:0,
        '& li':{
            padding:'0px 12px',
            listStyle:'none',
            '& > a':{
                boxSizing: 'border-box',
                width: '100%',
                //display: 'flex',
                alignItems:'center',
                fontFamily: theme.typography.fontFamily.primary,
                fontSize: 14,
                fontWeight:500,
                textDecoration: 'none',
                padding: '4px 8px',
                color: theme.palette.text.blue.primary,
                lineHeight: '20px',
                whiteSpace:'nowrap',
                '&:hover,&.active':{ 
                    background: theme.palette.background.darkBlue,
                    color:'#fff',
                    fontWeight:700,
                    textDecoration:'underline', 
                }
      }
    }
    }),
    loader:{
        margin:1,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        '& img':{
                maxWidth:'60%',
                objectFit:'scale-down',
                '&.loader-true':{
                    maxWidth:'40%',
                }
            }
    }
}
const DashboardMenu = ({permissions,handleClose})=>{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const [searchText,setSerchText] = useState(''); 
    const { clinicId, clinicDashboards } = useSelector(state => ({
        clinicId: state.clinicReducer.selectedClinicId,
        clinicDashboards: state.clinicReducer.clinicDashboards
    }), shallowEqual);
    useEffect(()=>{
        clinicId && !clinicDashboards[clinicId] && dispatch(clinicActions.fetchDashboards(clinicId,false));
    },[clinicId])
    const onSelect = (e)=>{
        setSerchText('');
        handleClose(e);
    }
    const regex = new RegExp(searchText, "im");
    const filteredDashboard = ({dashboards})=>{
        return dashboards.filter(i=> i.is_active && regex.test(i.display_name));
    }  
    const activeDashboards = useMemo(() => {
        const categories = clinicDashboards?.[clinicId]?.category;
        if(categories?.length){
            return categories.filter(item=>permissions.includes(item.child_resource.toUpperCase()))
        }
        
        return [];
    }, [clinicDashboards, clinicId]);
    const dashUrl = (dashName)=>GlobalRoutePath.LANDING.path+ "/" + dashName.toLowerCase()
    const isSelected = ({dashboard_name,display_default})=>{
        const pathName = window.location.pathname;
        const dashboardPath = matchPath({path: GlobalRoutePath.DASHBOARD.path, caseSensitive: true, end: true},pathName);
        return (dashboardPath && pathName == dashUrl(dashboard_name)) || (display_default && pathName == GlobalRoutePath.LANDING.path) 
    }
    return <Grid container sx={{...Sx.root,minWidth:(activeDashboards.length*170)}}>
        {!activeDashboards.length && <Grid size={12} sx={Sx.loader}><img className="loader" src={'/static/images/loader_transparent.gif'}/></Grid>}
        {!!activeDashboards.length && <Grid size={12} sx={Sx.search}><TextFieldWrapper 
            placeholder="Search Dashboard" 
            className="search" 
            value={searchText}
            onChange={(e)=>setSerchText(e.target.value)}
            slotProps={{
                input: searchText.length?{
                endAdornment: (
                    <InputAdornment position="end" onClick={()=>setSerchText('')}>
                    <ClearIcon />
                    </InputAdornment>
                )
                }:{}
            }}
            /></Grid>}
        {activeDashboards.map(group=><Grid key={group.name} size={12/activeDashboards.length} sx={Sx.group}>
            <Box className="heading">{group.name}</Box>
            <Box component="ul" sx={Sx.groupItems(theme)}>
              {filteredDashboard(group).map(dashboard => 
                    <li key={dashboard.dashboard_name} onClick={onSelect}>
                        <Link className={isSelected(dashboard) && 'active'} to={dashUrl(dashboard.dashboard_name)} title={dashboard.display_name}>{dashboard.display_name.ellipsis(30)}</Link>
                    </li>)}  
            </Box>
        </Grid>)}
    </Grid>
}

export default DashboardMenu;